// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__a-OHG","sub_footer":"Footer_sub_footer__JmdX+"};